import React from 'react'

import { syncWithRemoteConfig } from 'config/remoteConfig'
import $ from 'jquery'
import moment from 'moment'
import qs from 'qs'
import styled from 'styled-components'

import confirmationDetails from 'app/assets/icons/confirmation-details.svg'
import paperPlane from 'app/assets/icons/paper-plane.png'
import WelcomeImage from 'app/assets/icons/Welcome.svg'
import DefaultButton from 'app/components/buttons/default/component'
import {
  Alert,
  Box,
  Button,
  Flex,
  Modal,
} from 'app/components/design-system-components'
import * as Display from 'app/components/display/display'
import * as Headers from 'app/components/display/text/standard_text/standard-headings/component'
import MuvalBanner from 'app/Integrations/components/Muval/Banner'
import RentBondBanner from 'app/Integrations/components/RentBond/components/Banner'
import { RENTBOND_APP_SUBMIT_PARAM } from 'app/Integrations/components/RentBond/config'
import ThanksWidget from 'app/Integrations/components/Thanks/ThanksWidget'
import MortgageBanner from 'app/Integrations/Mortgage/Banner'
import theme from 'app/match/applicationReportPDF/assets/theme'
import {
  DIRECT_CONNECT_PROVIDER_NAME,
  UTILITY_CONNECTION_MODAL_QUERY_KEY,
} from 'app/match/apply/application_summary_before_submit/application_summary_before_submit.constants'
import DirectConnectTermsModal from 'app/match/apply/application_summary_before_submit/components/disclosure_consent_container/direct_connection_terms_modal'
import * as snugLogger from 'app/services/snugLogger'
import Checkbox from 'app/shared_components/checkbox'
import CopyableText from 'app/shared_components/CopyableText'
import { ErrorMessage } from 'app/shared_components/helpers'
import { history } from 'app/shared_components/router'
import { DashboardModal } from 'app/sm/apply/components/apply_form'
import Spinner from 'app/sm/common/spinner'
import {
  ApplicationCategory,
  isApplicantApplied,
  isStatusDeclined,
  isStatusWithdrawableByRenter,
  isStatusWithdrawn,
  urlTo,
} from 'app/sm/helpers'
import {
  ApplicantListComponent,
  ApplicationDetailsNumbersComponent,
} from 'app/sm/renter_applications/renter_application_detailed/components/new_applicant-details'
import {
  checkIfBGCheckNotSupportedInState,
  isStateVIC,
} from 'app/utils/address/helpers'
import {
  GTM_MUVAL_APPLICATION_CTA_BUTTON,
  RENTBOND_APPLICATION_CTA_BUTTON,
} from 'app/utils/google-tag-manager/helpers'
import { isEmpty } from 'app/utils/objects/helpers'
import { getUtilityProviderDisclosureConsent } from 'app/utils/utilityprovider/helpers'
import { FeatureFlag } from 'config/features'

import 'app/match/apply/application_confirmation/style.scss'

export const StyledCopyableAppIDContainer = styled.span`
  font-weight: ${theme.fontWeights[6]};
  font-size: ${theme.space[5]}px;
  color: ${theme.colors.gray600};
`

const BackgroundCheckContainer = styled(Box)`
  color: black;
  display: flex;
  flex-direction: column;
  width: 100%;
  .backgroundcheck-btn {
    display: flex;
    justify-content: start;
    button {
      width: fit-content;
    }
  }
`

const defaultUtilityProviderName = 'the utility connection provider'
const directConnectUtilityHeading =
  'One Last Thing: Optional Utility Connection'
const directConnectUtilityPrompt =
  'Would you like assistance setting up your utilities at your new home before viewing your application details?'
const directConnectUtilityDismissLabel = 'Dismiss'
const genericUtilityConnectionHeading = 'Plan your move'
const genericUtilityConnectionDismissLabel = 'Skip'
const buildGenericUtilityConnectionPrompt = (providerName) =>
  `Find out more about moving and utility connections with ${providerName}. Don't get left in the dark!`

const UtilityConnectionModalLayout = styled(Box)`
  margin: -12px -24px 0;
  width: calc(100% + 48px);
`

const UtilityConnectionModalHeader = styled(Flex)`
  align-items: center;
  background: ${theme.colors.warning100};
  border-bottom: 1px solid ${theme.colors.warning200};
  gap: 16px;
  padding: 24px 28px;
`

const UtilityConnectionHeaderAccent = styled(Box)`
  color: ${theme.colors.warning500};
  font-size: 22px;
  line-height: 1;
  margin-left: 4px;
`

const UtilityConnectionHeaderTitle = styled(Box)`
  color: ${theme.colors.gray900};
  flex: 1;
  font-size: 24px;
  font-weight: ${theme.fontWeights[6]};
  line-height: 1.2;
  white-space: nowrap;
`

const UtilityConnectionModalBody = styled(Box)`
  padding: 28px 24px 12px;
  width: 100%;
`

const UtilityConnectionPrompt = styled(Box)`
  color: ${theme.colors.gray700};
  font-size: 18px;
  font-weight: ${theme.fontWeights[4]};
  line-height: 1.45;
  margin-bottom: 24px;
  max-width: 92%;
`

const UtilityConnectionConsentCard = styled(Box)`
  background: ${theme.colors.gray100};
  border: 1px solid ${theme.colors.gray200};
  border-radius: 22px;
  padding: 18px 20px;
  width: 100%;
`

const UtilityConnectionModalFooter = styled(Flex)`
  justify-content: flex-end;
  margin: 0 -24px -24px;
  padding: 20px 32px 24px;
  width: calc(100% + 48px);
`

const UtilityConnectionButton = styled(Button)`
  && {
    min-width: 156px;
  }
`

const UtilityConnectionDismissButton = styled(UtilityConnectionButton)`
  && {
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray300};
    color: ${theme.colors.gray700};
  }
`

const UtilityConnectionContinueButton = styled(UtilityConnectionButton)`
  && {
    background: ${theme.colors.success600};
    border: 1px solid ${theme.colors.success600};
    color: ${theme.colors.white};
    margin-left: 12px;
  }

  &&:disabled {
    background: ${theme.colors.success300};
    border-color: ${theme.colors.success300};
    color: ${theme.colors.white};
    cursor: not-allowed;
  }
`

const UtilityConnectionErrorText = styled(Box)`
  color: ${theme.colors.error500};
  font-size: ${theme.fontSizes.pSmall12}px;
`

const NoWrapSpan = styled.span`
  white-space: nowrap;
`

const isVictorianState = (value = '') => isStateVIC(String(value).trim())

const shouldShowUtilityConnectionModalOnSubmit = () => {
  const query = new URLSearchParams(window.location.search)
  return query.get(UTILITY_CONNECTION_MODAL_QUERY_KEY) === '1'
}

const clearUtilityConnectionModalSubmitSignal = () => {
  const query = new URLSearchParams(window.location.search)
  if (!query.has(UTILITY_CONNECTION_MODAL_QUERY_KEY)) {
    return
  }

  query.delete(UTILITY_CONNECTION_MODAL_QUERY_KEY)
  const queryString = query.toString()
  const nextUrl = `${window.location.pathname}${
    queryString ? `?${queryString}` : ''
  }${window.location.hash || ''}`

  window.history.replaceState(window.history.state, '', nextUrl)
}

const getApplicantGuid = (applicant = {}) =>
  applicant.guidID || applicant.guidId || ''

const getCurrentConfirmationApplicant = (confirmationSummary = {}) => {
  const applicants = Array.isArray(confirmationSummary?.applicants)
    ? confirmationSummary.applicants
    : []
  const applicantGuid = confirmationSummary?.applicant_guid

  return (
    applicants.find(
      (applicant) => getApplicantGuid(applicant) === applicantGuid,
    ) ||
    applicants.find((applicant) => applicant?.isPrimary) ||
    null
  )
}

const buildApplicantDisclosureRequest = (
  applicant = {},
  {
    directConnectTermsViewed = false,
    optedToReceiveUtilityConnection = false,
  } = {},
) => {
  const disclosures =
    applicant?.disclosures && typeof applicant.disclosures === 'object'
      ? applicant.disclosures
      : {}
  const data = {
    ...disclosures,
    isPrimary: applicant?.isPrimary || false,
    optedToAcceptCondition: applicant?.optedToAcceptCondition || false,
    optedToAcceptDisclosureConsent:
      applicant?.optedToAcceptDisclosureConsent !== false,
    optedToReceiveUtilityConnection,
    directConnectTermsViewed,
    optedToReceiveRayWhiteConciergeService:
      applicant?.optedToReceiveRayWhiteConciergeService || false,
    optedToReceiveBondLoanInformation:
      applicant?.optedToReceiveBondLoanInformation || false,
    optedToRequirePostingClause:
      applicant?.optedToRequirePostingClause || false,
    smokingInfo: applicant?.smokingInfo || 0,
    optedInToPetConsent: applicant?.optedInToPetConsent || false,
    conditionAcceptanceType: applicant?.conditionAcceptanceType ?? 1,
    propertyInspectionType: applicant?.propertyInspectionType ?? 0,
    optedToReceiveEasyBondpay: applicant?.optedToReceiveEasyBondpay || false,
    optedToSkipViewingDisclosures:
      applicant?.optedToSkipViewingDisclosures || false,
  }

  if (applicant?.propertyInspectedDate) {
    data.propertyInspectedDate = applicant.propertyInspectedDate
  }

  return data
}

export const ApplicantList = ({ applicants }) => {
  return (
    <div>
      {applicants.map((applicant) => {
        return (
          <div className="list-applicants" key={applicant.guidID}>
            <div className="applicant-name">
              <p>
                {applicant.firstName} {applicant.lastName}
              </p>
            </div>
            <div className="applicant-status">
              {applicant.isPrimary ? (
                <div className="confirmation-status-general Applied">
                  Applied
                </div>
              ) : (
                <div
                  className={`confirmation-status-general ${
                    isApplicantApplied(applicant) ? 'Applied' : 'Invited'
                  }`}
                >
                  {isApplicantApplied(applicant) ? 'Applied' : 'Invited'}
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

class ApplyConfirmationSummary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      applyButtonClicked: false,
      modalOpened: '',
      spinner: false,
      propertyInvestmentsInformation: false,
      savingUtilityConnectionConsent: false,
      showDirectConnectTermsModal: false,
      showUtilityConnectionModal: false,
      utilityConnectionConsentChecked: true,
      utilityConnectionDirectConnectTermsViewed: false,
      utilityConnectionError: '',
      utilityConnectionModalInitialized: false,
      // Dirty counter bumped on remote-config updates to force a re-render so
      // getThanksOffersRemoteConfigSnapshot() is re-read. Not read in render().
      thanksRemoteConfigRevision: 0,
    }
    this.unsubscribeRemoteConfigUpdates = null
  }

  componentDidMount() {
    const { fetchApplicantConfirmationSummary, fetchRenterSummary } = this.props
    const { applicationId } = this.props.match.params
    $('#index').addClass('no-navbar-menu')
    $('.app-content-container').addClass('background-grey')
    this.unsubscribeRemoteConfigUpdates = syncWithRemoteConfig(
      this.handleThanksRemoteConfigUpdated,
    )
    if (applicationId) {
      this.setState({
        spinner: true,
      })
      fetchRenterSummary(applicationId)
        .then(({ renterSummary }) => {
          this.setState({ renterSummary }, () => {
            const { application = {}, proofOfIncome = {} } =
              this.state.renterSummary
            const { propertyInvestmentsInformation = false } =
              proofOfIncome || {}
            this.setState({
              application,
              spinner: false,
              propertyInvestmentsInformation,
            })
          })
        })
        .catch((error) => {
          this.setState(
            { loadingError: error, spinner: false },
            this.reactToastify,
          )
        })
      fetchApplicantConfirmationSummary(applicationId).then(
        (confirmationSummary) => {
          const applicationStatus = confirmationSummary
            ? ApplicationCategory[confirmationSummary.application_status]
            : ''
          const shouldRedirect =
            isStatusDeclined(applicationStatus) ||
            isStatusWithdrawn(applicationStatus) ||
            !confirmationSummary
          if (shouldRedirect) {
            history.push(urlTo('NotFound'))
          }
        },
      )
    }

    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    if (
      curQueries.hasOwnProperty('action') &&
      curQueries.action === 'movedApplicationWithdrawConfirmation'
    ) {
      this.toggleModal('withdrawOrDelete')
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    nextProps.setBackUrl('/')
  }

  componentDidUpdate() {
    if (this.state.utilityConnectionModalInitialized) {
      return
    }

    const { confirmationSummary = {} } = this.props
    const { renterSummary = {} } = this.state
    const currentApplicant = this.getCurrentApplicant()

    if (!confirmationSummary?.application_guid || isEmpty(renterSummary)) {
      return
    }

    const showUtilityConnectionModal =
      shouldShowUtilityConnectionModalOnSubmit() &&
      this.shouldShowUtilityConnectionModal()
    clearUtilityConnectionModalSubmitSignal()

    this.setState({
      showUtilityConnectionModal,
      utilityConnectionDirectConnectTermsViewed:
        currentApplicant?.directConnectTermsViewed || false,
      utilityConnectionModalInitialized: true,
    })
  }

  componentWillUnmount() {
    this.unsubscribeRemoteConfigUpdates?.()
    $('#index').removeClass('no-navbar-menu')
    $('.app-content-container').removeClass('background-grey')
  }

  handleThanksRemoteConfigUpdated = () => {
    // Bump the dirty counter to force a re-render; the value itself is unused.
    this.setState((prevState) => ({
      thanksRemoteConfigRevision: prevState.thanksRemoteConfigRevision + 1,
    }))
  }

  onApplyButtonClick = (applicationGUID, applicantId, isSecondaryApplicant) => {
    const { confirmationSummary } = this.props
    const applicationStatus = confirmationSummary.application_status
      ? ApplicationCategory[confirmationSummary.application_status]
      : undefined
    if (
      isStatusWithdrawableByRenter(applicationStatus) &&
      !isSecondaryApplicant
    ) {
      this.withdrawApplication(applicationGUID)
    } else if (
      isStatusWithdrawableByRenter(applicationStatus) &&
      isSecondaryApplicant
    ) {
      this.withdrawSecondaryApplicant(applicationGUID, applicantId)
    }
  }

  onContinueButtonClick() {
    this.props.resetState()
    history.push(urlTo('applications'))
  }

  toggleModal = (modalName) => {
    if (this.state.modalOpened === modalName) {
      this.setState({ modalOpened: '' })
    } else if (this.state.modalOpened === '') {
      this.setState({ modalOpened: modalName })
    }
  }

  withdrawApplication = (applicationGuid) => {
    const { acceptWithdraw } = this.props
    this.setState({
      applyButtonClicked: true,
    })
    acceptWithdraw(
      applicationGuid,
      () =>
        this.setState({
          applyButtonClicked: false,
        }),
      () =>
        this.setState({
          applyButtonClicked: false,
        }),
    )
  }

  withdrawSecondaryApplicant(applicationGuid, applicantId) {
    const { acceptSecondaryWithdraw } = this.props
    acceptSecondaryWithdraw(
      applicationGuid,
      applicantId,
      () =>
        this.setState({
          applyButtonClicked: false,
        }),
      () =>
        this.setState({
          applyButtonClicked: false,
        }),
    )
  }

  handleBackgroundCheckClick() {
    history.push(`${urlTo('BackgroundCheck')}?from=rentersummary`)
  }

  getCurrentApplicant = () => {
    return getCurrentConfirmationApplicant(this.props.confirmationSummary)
  }

  getUtilityProviderName = () => {
    return (
      this.state?.renterSummary?.utilityProvider?.name ||
      defaultUtilityProviderName
    )
  }

  shouldShowUtilityConnectionModal = () => {
    const { confirmationSummary = {} } = this.props
    const currentApplicant = this.getCurrentApplicant()
    const state =
      confirmationSummary?.address?.state ||
      this.state?.renterSummary?.application?.property?.address?.state ||
      ''

    return (
      isVictorianState(state) &&
      Boolean(
        confirmationSummary?.applicant_primary ?? currentApplicant?.isPrimary,
      )
    )
  }

  dismissUtilityConnectionModal = () => {
    this.setState({
      showUtilityConnectionModal: false,
      utilityConnectionError: '',
    })
  }

  toggleUtilityConnectionConsent = () => {
    this.setState((prevState) => ({
      utilityConnectionConsentChecked:
        !prevState.utilityConnectionConsentChecked,
    }))
  }

  openDirectConnectTermsModal = () => {
    this.setState({
      showDirectConnectTermsModal: true,
      utilityConnectionDirectConnectTermsViewed: true,
    })
  }

  closeDirectConnectTermsModal = () => {
    this.setState({
      showDirectConnectTermsModal: false,
    })
  }

  handleUtilityConnectionContinue = () => {
    const { updateApplicantDisclosures } = this.props
    const currentApplicant = this.getCurrentApplicant()
    const applicantGuid = getApplicantGuid(currentApplicant)

    if (!applicantGuid) {
      this.dismissUtilityConnectionModal()
      return Promise.resolve()
    }

    this.setState({
      savingUtilityConnectionConsent: true,
      utilityConnectionError: '',
    })

    return updateApplicantDisclosures(
      applicantGuid,
      buildApplicantDisclosureRequest(currentApplicant, {
        directConnectTermsViewed:
          this.state.utilityConnectionDirectConnectTermsViewed,
        optedToReceiveUtilityConnection:
          this.state.utilityConnectionConsentChecked,
      }),
    )
      .then(() => {
        this.setState({
          savingUtilityConnectionConsent: false,
          showUtilityConnectionModal: false,
        })
      })
      .catch((error) => {
        snugLogger.error('Failed to update utility connection consent', error)
        this.setState({
          savingUtilityConnectionConsent: false,
          utilityConnectionError:
            error?.message || 'Unable to update utility connection consent',
        })
      })
  }

  renderUtilityConnectionConsentLabel = (utilityProviderName) => {
    if (utilityProviderName === DIRECT_CONNECT_PROVIDER_NAME) {
      return (
        <div>
          Yes, I consent to my personal information being provided to{' '}
          {utilityProviderName}, including name, address, email and phone
          number, for the purpose of contacting me to connect electricity, gas
          and other services in my new home in accordance with the Data Sharing
          and Terms{' '}
          <NoWrapSpan>
            (
            <Button
              variant="linkBlueUnderlined"
              display="inline"
              onClick={() => this.openDirectConnectTermsModal()}
            >
              View Data Sharing and Terms
            </Button>
            ).
          </NoWrapSpan>{' '}
          If &apos;No&apos;, you won&apos;t be contacted about utilities and
          connection services. Direct Connect will automatically process water
          connection services for successful applicants based in Victoria.
        </div>
      )
    }

    return getUtilityProviderDisclosureConsent(
      utilityProviderName || defaultUtilityProviderName,
    )
  }

  renderUtilityConnectionModal = () => {
    const {
      savingUtilityConnectionConsent,
      showDirectConnectTermsModal,
      showUtilityConnectionModal,
      utilityConnectionConsentChecked,
      utilityConnectionError,
    } = this.state

    if (!showUtilityConnectionModal) {
      return null
    }

    const utilityProviderName = this.getUtilityProviderName()
    const isDirectConnectProvider =
      utilityProviderName === DIRECT_CONNECT_PROVIDER_NAME
    const modalHeading = isDirectConnectProvider
      ? directConnectUtilityHeading
      : genericUtilityConnectionHeading
    const modalPrompt = isDirectConnectProvider
      ? directConnectUtilityPrompt
      : buildGenericUtilityConnectionPrompt(
          utilityProviderName || defaultUtilityProviderName,
        )
    const dismissButtonLabel = isDirectConnectProvider
      ? directConnectUtilityDismissLabel
      : genericUtilityConnectionDismissLabel

    return (
      <>
        <Modal
          showModalHeading={false}
          takeDecreasedWidth
          modalBody={
            <UtilityConnectionModalLayout>
              <UtilityConnectionModalHeader>
                <UtilityConnectionHeaderAccent>✦</UtilityConnectionHeaderAccent>
                <UtilityConnectionHeaderTitle>
                  {modalHeading}
                </UtilityConnectionHeaderTitle>
              </UtilityConnectionModalHeader>
              <UtilityConnectionModalBody>
                <UtilityConnectionPrompt>{modalPrompt}</UtilityConnectionPrompt>
                <UtilityConnectionConsentCard>
                  <Checkbox
                    label={this.renderUtilityConnectionConsentLabel(
                      utilityProviderName,
                    )}
                    value={utilityConnectionConsentChecked}
                    onChange={this.toggleUtilityConnectionConsent}
                    spanClassName="gray-color fs16 height-auto width100"
                  />
                </UtilityConnectionConsentCard>
                {utilityConnectionError && (
                  <UtilityConnectionErrorText mt="12px">
                    {utilityConnectionError}
                  </UtilityConnectionErrorText>
                )}
              </UtilityConnectionModalBody>
            </UtilityConnectionModalLayout>
          }
          customModalFooter
          toggleModal={this.dismissUtilityConnectionModal}
          modalFooter={
            <UtilityConnectionModalFooter>
              <UtilityConnectionDismissButton
                onClick={this.dismissUtilityConnectionModal}
              >
                {dismissButtonLabel}
              </UtilityConnectionDismissButton>
              <UtilityConnectionContinueButton
                onClick={this.handleUtilityConnectionContinue}
                disabled={savingUtilityConnectionConsent}
              >
                {savingUtilityConnectionConsent ? 'Saving...' : 'Continue'}
              </UtilityConnectionContinueButton>
            </UtilityConnectionModalFooter>
          }
        />
        <DirectConnectTermsModal
          showDirectConnectTermsModal={showDirectConnectTermsModal}
          toggleModal={this.closeDirectConnectTermsModal}
        />
      </>
    )
  }

  render() {
    const { confirmationSummary, backgroundCheck } = this.props
    const {
      applicant_guid: applicantGuid,
      application_guid: applicationGuid,
      application_slug: applicationSlug,
      applicants,
      address,
      applicant_primary: applicantPrimary,
    } = confirmationSummary || {}
    const applicationStatus =
      confirmationSummary &&
      ApplicationCategory[confirmationSummary.application_status]
    const thanksSampleSeed =
      applicationGuid ||
      applicationSlug ||
      this.props.match.params.applicationId
    const thanksOffersSampleRate = FeatureFlag.ThanksOffers.sampleRate
    const {
      modalOpened,
      application = {},
      loadingError,
      spinner,
      renterSummary = {},
      propertyInvestmentsInformation,
    } = this.state

    const { state = '' } = address || {}
    const { weeklyRent = 0, term = '', leaseStartDate = '' } = application
    const formattedStartDate = moment(leaseStartDate).format('DD MMM YYYY')

    const { selfTenancyCheck = {} } = renterSummary || {}

    const { SelfTenancyCheckDoc = [] } = selfTenancyCheck || {}

    const hasSelfTenancyCheck =
      SelfTenancyCheckDoc && SelfTenancyCheckDoc.length > 0

    const { attachedToProfile, identityVerification = {} } =
      backgroundCheck || {}

    const backgroundCheckHelpText = identityVerification.result
      ? `You have a Background Check that's not attached to your application.`
      : 'Improve your application by adding a Background Check.'

    const backgroundCheckButtonText = identityVerification.result
      ? 'Review & Attach'
      : 'Add Background Check'

    const isExpired =
      confirmationSummary.expiredAt &&
      moment(confirmationSummary.expiredAt).isBefore(moment())

    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const { ballot = false } = curQueries || {}
    const viewApplicationHref = (() => {
      const fallback = urlTo('applicationSummary', {
        applicationId: applicationGuid,
      })
      const v2Url = renterSummary?.v2RedirectInfo?.redirectURL

      if (!v2Url) return fallback

      const separator = v2Url.includes('?') ? '&' : '?'
      return `${v2Url}${separator}scrollTo=review-and-submit`
    })()

    if (!isEmpty(loadingError)) {
      return <ErrorMessage error={loadingError} />
    }

    return (
      <div>
        {this.renderUtilityConnectionModal()}
        <Display.CenterContentContainer componentClass="col-xs-12 background-grey p0">
          <div className="ilustration-box">
            <img className="img-size" src={paperPlane} alt="Confirmation" />
          </div>

          <h3 className="heading fw600 pl0 pr0">
            Your application has been submitted
          </h3>
        </Display.CenterContentContainer>

        {spinner && <Spinner />}

        {!spinner && (
          <div>
            <Display.CenterContentContainer componentClass="col-xs-12 background-grey p0">
              <div className="mt15">
                <p>
                  The property manager has been notified of your application{' '}
                  <StyledCopyableAppIDContainer>
                    (App ID: <CopyableText text={applicationSlug} />)
                  </StyledCopyableAppIDContainer>{' '}
                  for {address.friendlyName}. We’ll let you know when they
                  respond.{' '}
                  <a href={viewApplicationHref}>View your application</a>
                </p>
              </div>
            </Display.CenterContentContainer>
            {!attachedToProfile &&
              !hasSelfTenancyCheck &&
              !ballot &&
              !checkIfBGCheckNotSupportedInState(state) && (
                <Display.CenterContentContainer componentClass="col-xs-12 background-grey p0">
                  <Alert variant="blueWithBg">
                    <Flex alignItems="center">
                      <img src={WelcomeImage} alt="welcome" />
                      <BackgroundCheckContainer ml="16px">
                        <Box>
                          {backgroundCheckHelpText}{' '}
                          <a
                            href="https://help.snug.com/hc/en-us/articles/360000132455"
                            target="_blank"
                            rel="noreferrer"
                          >
                            learn more
                          </a>
                        </Box>
                        <div className="backgroundcheck-btn">
                          <button
                            onClick={this.handleBackgroundCheckClick}
                            className="mt10 btn-success"
                          >
                            {backgroundCheckButtonText}
                          </button>
                        </div>
                      </BackgroundCheckContainer>
                    </Flex>
                  </Alert>
                </Display.CenterContentContainer>
              )}

            {!ballot && (
              <Display.CenterContentContainer componentClass="col-xs-12 background-grey p0">
                <Alert variant="blueWithBg" mt={5}>
                  <RentBondBanner
                    className={RENTBOND_APPLICATION_CTA_BUTTON}
                    linkParam={RENTBOND_APP_SUBMIT_PARAM}
                  />
                </Alert>
                <Alert variant="blueWithBg" mt={5}>
                  <MuvalBanner
                    trackingClassName={GTM_MUVAL_APPLICATION_CTA_BUTTON}
                  />
                </Alert>
                {propertyInvestmentsInformation && (
                  <Alert variant="blueWithBg" mt={5}>
                    <MortgageBanner />
                  </Alert>
                )}
                {FeatureFlag.ThanksOffers.isOn && (
                  <ThanksWidget
                    placement="applicationSubmitted"
                    sampleSeed={`application-confirmation-${thanksSampleSeed}`}
                    sampleRate={thanksOffersSampleRate}
                  />
                )}
              </Display.CenterContentContainer>
            )}

            <Display.CenterContentContainer
              componentClass="application-standard-shadow-box col-xs-12 summary-box-on-mobile"
              containerClass="mt30"
            >
              <Headers.SectionHeader text="My Details" textClass="fw600" />
              <Display.GreyContainer containerClass="application-details-container ml25">
                <Display.ContainerHeader
                  text="Preference"
                  isEditable={false}
                  icon={confirmationDetails}
                />
                <div className="display-flex flex-wrap-wrap">
                  <ApplicationDetailsNumbersComponent
                    title="Rent"
                    text={`${weeklyRent}`}
                    componentClassName="width50p align-items-start flex-basis-25p"
                    extraText="/w"
                    titleClassName="preference-label"
                    textClassName="preference-content"
                  />
                  <ApplicationDetailsNumbersComponent
                    title="Term"
                    text={term}
                    componentClassName="width50p align-items-start flex-basis-25p"
                    extraText="months"
                    titleClassName="preference-label"
                    textClassName="preference-content"
                  />
                  <ApplicationDetailsNumbersComponent
                    title="Lease Start"
                    text={formattedStartDate}
                    componentClassName="width50p align-items-start flex-basis-25p"
                    titleClassName="preference-label"
                    textClassName="preference-content"
                  />
                  <ApplicationDetailsNumbersComponent
                    title="Application ID"
                    text={applicationSlug}
                    componentClassName="width50p align-items-start flex-basis-25p"
                    titleClassName="preference-label"
                    textClassName="preference-content"
                  />
                </div>
                {applicants.length > 0 && (
                  <ApplicantListComponent
                    application={application}
                    applicants={applicants}
                    avatarContainerClass="mobile-hide align-items-center"
                  />
                )}
              </Display.GreyContainer>
            </Display.CenterContentContainer>

            <Display.BottomContentContainer>
              <Display.CenterContentContainer componentClass="width100">
                <div className="bottom-buttons-mobile-wrapper">
                  {!isExpired && (
                    <div>
                      {isStatusWithdrawableByRenter(applicationStatus) && (
                        <div className="apply-form-buttons">
                          <button
                            className="btn btn-left xs-text-center back-button-link summary-grey-button-class width-auto withdraw-button-spacing"
                            onClick={() => this.toggleModal('withdrawOrDelete')}
                          >
                            <span className="mt8">Withdraw</span>
                          </button>
                        </div>
                      )}
                      {modalOpened === 'withdrawOrDelete' && (
                        <DashboardModal
                          toggleModal={() =>
                            this.toggleModal('withdrawOrDelete')
                          }
                          onButtonClick={this.onApplyButtonClick}
                          applicationId={applicationGuid}
                          label="Withdraw"
                          disabled={this.state.applyButtonClicked}
                          applicantId={applicantGuid}
                          isSecondaryApplicant={!applicantPrimary}
                        />
                      )}
                    </div>
                  )}
                  <DefaultButton
                    text="My applications"
                    onClick={() => this.onContinueButtonClick()}
                    size="large"
                    buttonType="default"
                  />
                </div>
              </Display.CenterContentContainer>
            </Display.BottomContentContainer>
          </div>
        )}
      </div>
    )
  }
}

export default ApplyConfirmationSummary
